class TokenStorage {
  storageKey = "auth";

  token = localStorage.getItem(this.storageKey);

  set(token) {
    localStorage.setItem(this.storageKey, token);

    this.token = token;
  }

  get() {
    if (this.token) {
      return this.token;
    }

    const token = localStorage.getItem(this.storageKey);
    this.token = token;

    return token;
  }

  remove() {
    if (!this.token) return;

    localStorage.removeItem(this.storageKey);
    this.token = null;
  }
}

export default TokenStorage;
